
export const baseUrl = {
    // prod:'https://preview.nongluekeji.com/qingyun/api',
    // prod: 'http://192.168.0.194:18090/api',
    prod:'https://cloud.shuziqingyun.com/api',//pro
    test: ''
}
export const miniId = "1562726115712745474"


// WEBPACK FOOTER //
// ./src/utils/apiUrl.js